import Cookies from 'universal-cookie';
import getEnvs from '@clearscore/helpers.envs';

const cookies = new Cookies();

const getDefaultOptions = () => ({
    domain: getEnvs('COOKIE_DOMAIN'),
    path: '/',
});

/**
 * set cookie
 * @param cookieName
 * @param payload
 * @param options
 */
export const setCookie = (cookieName, payload, options) => {
    const cookieValue = typeof payload === 'object' ? JSON.stringify(payload) : payload;

    cookies.set(cookieName, cookieValue, {
        ...getDefaultOptions(),
        ...options,
    });
};

/**
 * get cookie
 * @param cookieName
 */
export const getCookie = (cookieName) => cookies.get(cookieName);
/**
 * get all cookies
 * @param options
 */
export const getAllCookies = (options) => cookies.getAll(options);

/**
 * deletes cookie
 * @param cookieName
 */

export const removeCookie = (cookieName) => {
    cookies.remove(cookieName, getDefaultOptions());
    cookies.remove(cookieName);
};

export default cookies;
